// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__Zb9bs","textcolor":"Cover_textcolor__at4is","body":"Cover_body__dROmz"};